/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */

import { createSlice } from "@reduxjs/toolkit";
import { orgSettingsState } from "./orgSettings.state";

const orgSettingsSlice = createSlice({
    name: "orgSettings",
    initialState: orgSettingsState,
    reducers: {
        setOrgSettings (state, action) {
            state.orgSettings = action.payload;
        },
    }
});

export const orgSettingsReducer = orgSettingsSlice.reducer;

export const {
    setOrgSettings,
} = orgSettingsSlice.actions;
